import React from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Row, Table } from 'reactstrap';
import Select from 'react-select';
import { topConsignee } from 'actions/dashboardActionTopConsignee';

let month_option = [
    { value: '01', label: 'Januari' },
    { value: '02', label: 'Februari' },
    { value: '03', label: 'Maret' },
    { value: '04', label: 'April' },
    { value: '05', label: 'Mei' },
    { value: '06', label: 'Juni' },
    { value: '07', label: 'Juli' },
    { value: '08', label: 'Agustus' },
    { value: '09', label: 'September' },
    { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' },
    { value: '12', label: 'Desember' }
]

let year_option = [];

let limit_option = [
    { value: '5', label: '5' },
    { value: '10', label: '10' },
    { value: '15', label: '15' },
    { value: '20', label: '20' }
];

class TopConsignee extends React.Component {

    constructor(props) {
        super(props);
        let date = new Date();
        let bulan = date.getMonth() < 9 ? '0' + date.getMonth() : date.getMonth();

        for (let t = 2019; t <= date.getFullYear(); t++) {
            year_option.push({
                value: t.toString(),
                label: t.toString()
            })
        }

        this.state = {
            firstContent: true,
            bulan: bulan.toString(),
            tahun: date.getFullYear().toString(),
            kode: null,
            limit: '5'
        }

        this.handleFilter = this.handleFilter.bind(this);
    }

    componentDidMount() {
        this.props.topConsignee({
            tahun: this.state.tahun,
            bulan: this.state.bulan,
            limit: this.state.limit
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.success) {
            this.setState({
                firstContent: false
            })
        }
    }

    handleFilter(e) {
        let filter = {
            tahun: this.state.tahun,
            bulan: this.state.bulan,
            limit: this.state.limit
        }

        if (this.state.kode !== null) {
            filter.kode = this.state.kode;
        }
        this.props.topConsignee(filter)
    }

    render() {
        if (this.state.firstContent && this.props.loading) {
            return <div>Loading...</div>
        }
        return (
            <div>
                <Card>
                    <CardHeader className="text-center">
                        <h5>Top Consignee</h5>
                    </CardHeader>
                    <CardBody>
                        <Form>
                            <Row form>
                                <Col>
                                    <FormGroup>
                                        {

                                            <Select
                                                placeholder="Trayek"
                                                options={this.props.realisasiData !== null && this.props.realisasiData.kode_trayek}
                                                onChange={
                                                    (value) => {
                                                        this.setState({
                                                            kode: value !== null ? value.value : null
                                                        })
                                                    }
                                                }
                                                isDisabled={this.props.loading}
                                                isClearable
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Select
                                            placeholder="Bulan"
                                            onChange={(v) => this.setState({ bulan: v.value })}
                                            defaultValue={month_option.filter(f => f.value === this.state.bulan)}
                                            options={month_option}
                                            isDisabled={this.props.loading}
                                        // isClearable
                                        />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Select
                                            placeholder="Tahun"
                                            onChange={(v) => this.setState({ tahun: v.value })}
                                            defaultValue={year_option.filter(f => f.value === this.state.tahun)}
                                            options={year_option}
                                            isDisabled={this.props.loading}
                                        // isClearable
                                        />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Select
                                            placeholder="Limit"
                                            onChange={(v) => this.setState({ limit: v.value })}
                                            defaultValue={limit_option.filter(f => f.value === this.state.limit)}
                                            options={limit_option}
                                            isDisabled={this.props.loading}
                                        // isClearable
                                        />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Button
                                            color="primary"
                                            onClick={this.handleFilter}
                                            disabled={this.props.loading}
                                        >
                                            {
                                                this.props.loading ?
                                                    'Loading...'
                                                    :
                                                    <React.Fragment>
                                                        <i className="fa fa-search"></i> Cari
                                                    </React.Fragment>
                                            }
                                        </Button>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Table bordered hover striped size="sm">
                                    <thead>
                                        <tr>
                                            <th className="text-center">No</th>
                                            <th className="text-center">Kode Trayek</th>
                                            <th className="text-center">Nama Kapal</th>
                                            <th className="text-center">Consignee</th>
                                            <th className="text-center">Jumlah Order</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.props.loading ?
                                                <tr><td colSpan="5" className="text-center">Loading...</td></tr>
                                                :
                                                this.props.data.data !== undefined &&
                                                    this.props.data.data.length > 0 ?
                                                    this.props.data.data.map((item, key) => (
                                                        <tr key={key}>
                                                            <td className="text-center">{key + 1}</td>
                                                            <td>{item.kode_trayek}</td>
                                                            <td>{item.nama_kapal}</td>
                                                            <td>{item.nama_perusahaan}</td>
                                                            <td className="text-center">{item.banyak_order}</td>
                                                        </tr>
                                                    ))
                                                    :
                                                    <tr><td colSpan="5" className="text-center">No Data</td></tr>

                                        }
                                    </tbody>
                                </Table>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        loading: state.DashboardTopConsignee.topConsignee.loading,
        data: state.DashboardTopConsignee.topConsignee.data,
        error: state.DashboardTopConsignee.topConsignee.error,
        success: state.DashboardTopConsignee.topConsignee.success,

        realisasiData: state.dashboard.realisasiData,
        realisasiIsSuccess: state.dashboard.realisasiSuccess,
        realisasiHasError: state.dashboard.realisasiError,
        realisasiIsLoading: state.dashboard.realisasiLoading,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        topConsignee: (data) => dispatch(topConsignee(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopConsignee);